import dayjs from 'dayjs';

export const getYears = (sailings) => {
  const years = sailings.map((date) => dayjs(date).format('YYYY')).sort((a, b) => a - b);
  const uniqueYears = [...new Set(years)];
  return uniqueYears.map((date) => {
    return { label: `${date}`, value: `${date}` };
  });
};

export const getMonths = (sailings, year, localizedDayjs, isDesktop = false) => {
  const monthsObj = sailings
    .filter((date) => localizedDayjs(date).format('YYYY') === year)
    .map((date) => localizedDayjs(date)) // turns filter results in a date object
    .sort((a, b) => a - b)
    .map((date) => {
      return {
        label: isDesktop ? localizedDayjs(date).format('MMMM') : localizedDayjs(date).format('MMM'),
        value: localizedDayjs(date).format('MM'),
      };
    });

  // get unique values for months getMonths object
  const key = 'label';
  return [...new Map(monthsObj.map((item) => [item[key], item])).values()];
};

export const getDays = (sailings, selectedYear, selectedMonth, localizedDayjs) => {
  return sailings
    .filter(
      (date) =>
        localizedDayjs(date).format('YYYY') === selectedYear &&
        localizedDayjs(date).format('MM') === selectedMonth,
    )
    .map((day) => localizedDayjs(day).format('DD'))
    .sort((a, b) => a - b);
};
